import { useQuery } from '@tanstack/react-query';
import { Rank } from '@domain/insights/models/Rank';
import { container } from '@infrastructure/container';

export const useRanks = (productId: string) => {
  const {
    data: ranks,
    isLoading: isLoadingRanks,
    error: ranksError
  } = useQuery<Rank[]>({
    queryKey: ['ranks', productId],
    queryFn: async () => {
      const result = await container.insightsRepository.getRanksByProductId(productId);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
    enabled: !!productId,
    refetchOnWindowFocus: false,
    staleTime: 0,
    refetchOnMount: true,
  });

  return {
    ranks,
    isLoading: isLoadingRanks,
    error: ranksError
  };
};

